<div class="notMob">
  <div  *ngIf="firstnode | async as item">
  <!-- <div class="hidden-sm" *ngIf="item.uid=='SeqirusFluadRWEFirstComponent'">
  <div class="breadcrumbs--page-nav hidden-xs hidden-sm" *ngIf="!webEnabled">
      <div class="container">
          <p><a routerLink="/">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a routerLink="/products">{{"statictext.products" | cxTranslate}}</a><span> &gt; </span><strong>{{"statictext.realworldevidence" | cxTranslate}}</strong></p></div>
  </div>
  </div> -->
  <section class="landingpage_videoContainer fluad-video hidden-xs hidden-sm" *ngIf="firstnode | async as item">  
      <div *ngIf="item.uid=='SeqirusFluadRWEFirstComponent'">
          <div class="hero-frame">
              <div class="hero-scale">
                <section class="fluad-hero is-animating" aria-label="FLUAD hero animation">
                  <img class="hero__logo" [src]="getImage(item.media)" alt="FLUAD logo"  />
                  <!-- <img class="hero__shield-hold" src="../../../assets/images/shield-small.png" alt="Shield hold" /> -->
                  <img class="hero__shield" [src]="getImage(item.picture2)" alt="Shield" />
          
                  <h1 class="hero__headline" [innerHTML]="item.headline">
                  </h1>
          
                  <p class="hero__subhead" [innerHTML]="item.h2content">
                  
                  </p>
          
                  <div class="hero__lines" aria-hidden="true">
                    <span class="line line--top"></span>
                    <span class="line line--bottom"></span>
                  </div>
          
                  <div class="hero__callout">
                    <p class="callout__title" [innerHTML]="item.h3content"></p>
                  </div>
          
                  <aside class="hero__panel" aria-label="Additional information">
                    <p class="panel__body" [innerHTML]="item.content">
                     
                    </p>
                  </aside>
          
  
                </section>
              </div>
            </div>
  </div>
  </section>
  </div>
  </div>
  
  
  <section class="landingpage_videoContainer hidden-lg" *ngIf="firstnode | async as item">
      <div *ngIf="item.uid=='SeqirusFluadRWEFirstMobComponent'">
        <!-- Mobile hero (350px–768px) -->
    <section class="fluad-hero hero--mobile" aria-label="FLUAD hero mobile">
      <img class="m-logo" [src]="getImage(item.media)" alt="FLUAD logo" />
  
      <!-- FRAME 1: Start on shield (small) -->
      <img class="m-shield" [src]="getImage(item.picture2)" alt="Shield" />
  
      <!-- FRAME 4–5: Headline and supporting text (centered on shield) -->
      <h1 class="m-headline" [innerHTML]="item.headline"></h1>
      <p class="m-subhead" [innerHTML]="item.h2content"></p>
  
      <!-- FRAME 6: Gradient rectangle expands downward; ACIP text fades in -->
      <div class="m-rect" aria-hidden="true"></div>
      <div class="m-acip">
        <p class="m-acip__title" [innerHTML]="item.h3content"></p>
        <p class="m-acip__body" [innerHTML]="item.content"></p>
      </div>
    </section>
      <!-- <div *ngIf="item.mediaVideo">
      <video autoplay muted="" playsinline="" class="rwe_video" preload="auto"> 
          <source [src]="getImage(item.mediaVideo)" type="video/mp4">
      </video>
     </div> -->
  </div>
   </section>